import React from 'react';
import './ContactForm.scss';
import icon from '../../assets/banner/icons/Calling.png';
import { useTranslation } from '../../i18n/useTranslation';

const ContactForm = () => {
    const { t } = useTranslation();
    
    const handleClick = () => {
        const whatsappLink = 'https://api.whatsapp.com/send?phone=+962792602666&text=Hello%20doctor%20can%20I%20book%20an%20appointment?';
        window.open(whatsappLink, '_blank');
    };
    
    return (
        <div>
            <div className="row">
                <div className="col-lg-6">
                    <button onClick={handleClick} className="btn appointment-btn">{t('appointment.bookAppointment')}</button>
                </div>
                <div className="col-lg-6">
                    <div className="appointment-call">
                        <div className='icon'>
                            <img src={icon} alt="icon" />
                        </div>
                        <div className='call-text'>
                            <p>{t('appointment.takeCareOfSmile')}</p>
                            <h6 className="phone-number">079 260 2666</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;